var React = require('react');

function BackIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.82093 10.8201C5.06221 11.0732 5.45395 11.0572 5.67626 10.785L5.85573 10.5654C6.05673 10.3193 6.04656 9.95009 5.83236 9.71702L1.95666 5.5L5.83236 1.28298C6.04656 1.04991 6.05673 0.680683 5.85573 0.434643L5.67626 0.214957C5.45395 -0.0571732 5.06221 -0.0732148 4.82093 0.179932L0.175178 5.05429C-0.0583931 5.29936 -0.0583925 5.70064 0.175179 5.94571L4.82093 10.8201Z","fill":"#A5A9AF"}));
}

BackIconInline.defaultProps = {"width":"6","height":"11","viewBox":"0 0 6 11","fill":"none"};

module.exports = BackIconInline;

BackIconInline.default = BackIconInline;
